import { render, staticRenderFns } from "./login.vue?vue&type=template&id=1f0266b2&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f0266b2')) {
      api.createRecord('1f0266b2', component.options)
    } else {
      api.reload('1f0266b2', component.options)
    }
    module.hot.accept("./login.vue?vue&type=template&id=1f0266b2&", function () {
      api.rerender('1f0266b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/login.vue"
export default component.exports